var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V9.80721C21 9.78811 20.9997 9.76904 20.9992 9.75H15C14.0335 9.75 13.25 8.9665 13.25 8V2ZM11.75 11.2C11.75 12.415 10.7426 13.4 9.5 13.4C8.25736 13.4 7.25 12.415 7.25 11.2C7.25 9.98497 8.25736 9 9.5 9C10.7426 9 11.75 9.98497 11.75 11.2ZM5 15.6C5 14.9925 5.50368 14.5 6.125 14.5H12.875C13.4963 14.5 14 14.9925 14 15.6C14 18.0301 11.9853 20 9.5 20C7.01472 20 5 18.0301 5 15.6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2768 8.24999L14.8399 2.61172C14.8108 2.58151 14.7808 2.55232 14.75 2.52417V7.99999C14.75 8.13806 14.8619 8.24999 15 8.24999H20.2768Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalFile);
export default __webpack_public_path__ + "static/media/personal-file.ec4bc6da0eee259d1defc61409917bf1.svg";
export { ForwardRef as ReactComponent };